import * as React from 'react'
import { inject } from 'mobx-react'
import LocalizationStore from '../../../Stores/LocalizationStore'
// import * as Moment from 'moment'
import DateTimeHelper from '../../../Helpers/DateTimeHelper'
import {
    IQuestionnaireUserHistoryItem,
    getQuestionnaireStatusClass,
    getQuestionnaireStatusTextForList
} from '../../../Model/Questionnaire'

export interface IQuestionnaireUserHistoryItemProps {
    questionnaireUserHistoryItem: IQuestionnaireUserHistoryItem,
    className?: string,
    localizationStore?: LocalizationStore
}

@inject('localizationStore')
export default class QuestionnaireUserHistoryItemView extends React.Component<IQuestionnaireUserHistoryItemProps> {
    render() {
        const { questionnaireUserHistoryItem, localizationStore, className } = this.props
        return (
            <div className={className}>
                <p className="historyChangeDate">
                    {DateTimeHelper.formatDateForList(questionnaireUserHistoryItem.createDate)}
                    {/* {Moment(questionnaireUserHistoryItem.createDate!.toString()).format('DD.MM.YYYY')} */}
                </p>
                <div className="historyChangeStatus">
                    <p>
                        <span className="userName">{questionnaireUserHistoryItem.userName + ' '}</span>
                        {localizationStore!.t!('changeStatusTo') + ' '}
                    </p>
                    <span
                        className={getQuestionnaireStatusClass(questionnaireUserHistoryItem.status)}
                    >
                        {getQuestionnaireStatusTextForList(questionnaireUserHistoryItem.status)}
                    </span>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Questionnaire/QuestionnaireUserHistoryItemView.tsx